export enum ZapTypes {
  BUSINESS_STARTED_QUIZ = 'Business started quiz',
  USER_MATCHING_PREFERENCE = 'User Matching Preference',
  USER_PAID_MEMBERSHIP = 'User Paid Membership',
  USER_SCHEDULED_MATCHING_CALL_WITH_MENTO = 'User Scheduled Matching Call With Mento',
  USER_STARTED_QUIZ = 'User Started Quiz',
}
